import { __decorate } from "tslib";
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Editor, EditorContent } from '@tiptap/vue-2';
import StarterKit from '@tiptap/starter-kit';
import TextAlign from '@tiptap/extension-text-align';
import { Column, Columns } from '@/utils/tiptapColumns';
import { VALIDATION_RULES } from '@/constants/ValidationRules';
import { CONTRACT_PLACEHOLDERS, findUnknownPlaceholders } from '@/constants/ContractPlaceholders';
import { existingTemplateKeys } from '@/utils/templateKeys';
import Snackbar from '@/components/Snackbar.vue';
let ContractTemplateEditor = class ContractTemplateEditor extends Vue {
    value;
    base;
    editor = null;
    templateKey = '';
    title = '';
    bodyHtml = '';
    validFrom = '';
    validTo = '';
    saving = false;
    rules = VALIDATION_RULES;
    placeholders = CONTRACT_PLACEHOLDERS;
    alignments = ['left', 'center', 'right', 'justify'];
    get open() {
        return this.value;
    }
    set open(value) {
        this.$emit('input', value);
    }
    get keyItems() {
        return existingTemplateKeys();
    }
    get unknownPlaceholders() {
        return findUnknownPlaceholders(this.bodyHtml);
    }
    mounted() {
        this.editor = new Editor({
            extensions: [StarterKit, TextAlign.configure({ types: ['heading', 'paragraph'] }), Columns, Column],
            content: '',
            onUpdate: ({ editor }) => {
                this.bodyHtml = editor.getHTML();
            },
        });
        this.load();
    }
    beforeDestroy() {
        this.editor?.destroy();
    }
    onOpen(value) {
        if (value)
            this.load();
    }
    load() {
        this.templateKey = this.base?.data.key ?? '';
        this.title = this.base?.data.title ?? '';
        this.bodyHtml = this.base?.data.bodyHtml ?? '';
        this.validFrom = this.base?.data.validFrom ?? '';
        this.validTo = this.base?.data.validTo ?? '';
        this.editor?.commands.setContent(this.bodyHtml);
    }
    periodRule() {
        return !this.validFrom || !this.validTo || this.validFrom <= this.validTo || 'Platnost do musí být po platnosti od';
    }
    token(key) {
        return `{{${key}}}`;
    }
    insertPlaceholder(key) {
        this.editor?.chain().focus().insertContent(`{{${key}}}`).run();
    }
    close() {
        this.open = false;
    }
    async save() {
        if (!this.$refs.form.validate())
            return;
        if (this.unknownPlaceholders.length) {
            Snackbar.error('Šablona obsahuje neznámá pole');
            return;
        }
        if (!this.bodyHtml || this.bodyHtml === '<p></p>') {
            Snackbar.error('Šablona je prázdná');
            return;
        }
        if (this.saving)
            return;
        this.saving = true;
        try {
            await this.$store.dispatch('contract/storeTemplate', {
                key: this.templateKey,
                title: this.title,
                bodyHtml: this.bodyHtml,
                validFrom: this.validFrom || null,
                validTo: this.validTo || null,
            });
            Snackbar.success('Verze šablony uložena');
            this.open = false;
        }
        catch (e) {
            console.error(e);
            Snackbar.error(e.message || 'Uložení se nezdařilo');
        }
        finally {
            this.saving = false;
        }
    }
};
__decorate([
    Prop({ default: false })
], ContractTemplateEditor.prototype, "value", void 0);
__decorate([
    Prop({ default: null })
], ContractTemplateEditor.prototype, "base", void 0);
__decorate([
    Watch('value')
], ContractTemplateEditor.prototype, "onOpen", null);
ContractTemplateEditor = __decorate([
    Component({ components: { EditorContent } })
], ContractTemplateEditor);
export default ContractTemplateEditor;
